import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchAllCountries = () => {
  return {
    types: [
      actionTypes.FETCH_COUNTRIES_LOADING,
      actionTypes.FETCH_COUNTRIES_SUCCESS,
      actionTypes.FETCH_COUNTRIES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/localization/countries`,
      }),
  };
};

export const fetchAllStates = () => {
  return {
    types: [
      actionTypes.FETCH_COUNTRY_STATES_LOADING,
      actionTypes.FETCH_COUNTRY_STATES_SUCCESS,
      actionTypes.FETCH_COUNTRY_STATES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/localization/states`,
      }),
  };
};

export const fetchAllEUCountries = () => {
  return {
    types: [
      actionTypes.FETCH_EU_COUNTRIES_LOADING,
      actionTypes.FETCH_EU_COUNTRIES_SUCCESS,
      actionTypes.FETCH_EU_COUNTRIES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/localization/eu-countries`,
      }),
  };
};
